import cn from "classnames";
import { useTranslation } from "react-i18next";

import { SizesListProps } from "./SizesList.types";

import styles from "./SizesList.module.scss";

const SizesList = ({
  barcodes,
  selectedSizeValueId,
  onSizeButtonClick
}: SizesListProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.sizesList} data-testid="productInfo--sizes">
      {barcodes.map((barcode) => (
        <button
          key={barcode.id}
          className={cn(styles.sizesList_item, {
            [styles.sizesList_item__active]:
              selectedSizeValueId === barcode.sizeAttributeValueId
          })}
          onClick={() => onSizeButtonClick(barcode.sizeAttributeValueId)}
        >
          {t(barcode.sizeAttributeValue.value)}
        </button>
      ))}
    </div>
  );
};

export default SizesList;
